type EventCallback = (e: Event) => void

export function on(element: HTMLElement | Document, eventName: string, func: EventCallback): void {
  if (element.addEventListener) {
    element.addEventListener(eventName, func, false)
  }
}

export function off(element: HTMLElement | Document, eventName: string, func: EventCallback): void {
  if (element.removeEventListener) {
    element.removeEventListener(eventName, func, false)
  }
}
